import * as Monoid from "fp-ts/Monoid";

export const bigIntSum: Monoid.Monoid<bigint> = {
  concat: (x, y) => x + y,
  empty: 0n,
};

export const last = <T>(empty: T): Monoid.Monoid<T> => ({
  concat: (_, y) => y,
  empty,
});
